// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"83965cf7","213":"bb91ec31","417":"465d32f2","732":"d771bc6b"}[chunkId] + ".chunk.js";
};